import { request, request_v2 } from './http';
import { RAG_ENV } from './http';
import { ADDON_MAPPER } from '../config/common';

/**
 *  AI API
 */
export const getAiModels = async () => {
	return await request('GET', '/admin/ai/models');
};

export const getAiModelsLimits = async () => {
	return await request('GET', '/admin/ai/limits');
};

export const getAiInstructions = async (type = null) => {
	var service = process.env.REACT_APP_SERVICE_NAME;
	const url = type
		? `/admin/ai/instructions?service=${service}&type=${type}`
		: `/admin/ai/instructions?service=${service}`;
	return await request('GET', url);
	1;
};

export const getAiInstruction = async (id) => {
	const url = `/admin/ai/instruction/${id}`;
	return await request('GET', url);
};

export const createAiInstruction = async (name, instruction, type, enabled) => {
	var service = process.env.REACT_APP_SERVICE_NAME;
	return await request('POST', '/admin/ai/instruction', {
		service,
		name,
		instruction,
		type,
		enabled,
	});
};

export const updateAiInstruction = async (id, name, instruction, type, enabled) => {
	var service = process.env.REACT_APP_SERVICE_NAME;
	return await request('POST', '/admin/ai/instruction', {
		id,
		service,
		name,
		instruction,
		type,
		enabled,
	});
};

export const deleteAiInstruction = async (id) => {
	const url = `/admin/ai/instruction/${id}`;
	return await request('DELETE', url);
};

export const retrieveTokenCount = async (message, modelId, instruction) => {
	return await request('POST', '/admin/ai/token_count', { message, modelId, instruction });
};

export const retrieveCompletion = async (
	message,
	modelId,
	maxTokensInResponse = 500,
	instruction = ''
) => {
	return await request('POST', '/admin/ai/send/completion', {
		message,
		modelId,
		maxTokensInResponse,
		instruction,
	});
};

export const clearThemeCache = async (dbs = '') => {
	let clearUrl = '/admin/lawreports/categories/cache';

	if (dbs !== '') {
		clearUrl = `${clearUrl}?databases=${dbs}`;
	}

	const result = await request('DELETE', clearUrl);

	return result;
};

/**
 *  REDIS API
 */

export const getRedisMemoryUsage = async () => {
	return await request('GET', '/redis/memory-usage');
};

export const clearAllRedisCache = async () => {
	return await request('DELETE', '/redis/delete/all');
};

/**
 *  ORGANIZATION API
 */

export const getOrganization = async (id) => {
	return await request('GET', `/admin/organization/${id}`);
};

export const getOrganizations = async () => {
	return await request('GET', `/admin/organization/`);
};

export const createOrganization = async (organization) => {
	return await request('POST', '/admin/organization/', organization);
};

/* Original Organization delete.

export const deleteOrganization = async (id) => {
	return await request('DELETE', `/admin/organization/${id}`);
};
*/

export const deleteOrganization = async (id) => {
	return await request('POST', `/admin/organization/${id}/mark_delete`);
};

export const restoreOrganization = async (id) => {
	return await request('DELETE', `/admin/organization/${id}/unmark_delete`);
};

export const updateOrganization = async (id, organization) => {
	return await request('PUT', `/admin/organization/${id}`, organization);
};

/**
 *  AddOn API
 */
export const getAddOn = async (id) => {
	return await request('GET', `/admin/addon/${id}`);
};

export const getAddOns = async () => {
	return await request('GET', `/admin/addon/`);
};

export const getAddOnTypes = async () => {
	const addOnTypes = await request('GET', `/admin/addon/types`);

	return addOnTypes.map((item) => ({
		key: item,
		name: ADDON_MAPPER.LIST[item],
	}));
};

export const getAddOnAccountTypes = async () => {
	return await request('GET', `/admin/addon/account_types`);
};

export const getAddOnsByType = async (addOnType = '', id) => {
	return await request('GET', `/admin/addon/${addOnType.toUpperCase()}/${id}`);
};

export const createAddOn = async (addOn) => {
	return await request('POST', '/admin/addon/', addOn);
};

export const createAddOns = async (addOns = []) => {
	return await request('POST', '/admin/addon/bulk', {
		addOns,
	});
};

export const deleteAddOn = async (id) => {
	return await request('DELETE', `/admin/addon/${id}`);
};

export const deleteAddOns = async (ids = []) => {
	return await request('DELETE', `/admin/addon/bulk?ids=${ids.join(',')}`);
};

export const updateAddOn = async (id, addOn) => {
	return await request('PUT', `/admin/organization/${id}`, addOn);
};

/**
 *  Users API
 */
export const getUsers = async (orgId) => {
	return await request('GET', `/admin/user/organization/${orgId}`);
};

export const getUser = async (id) => {
	return await request('GET', `/admin/user/${id}`);
};

export const createUser = async (user, shared = false) => {
	return await request('POST', `/admin/user/${shared ? 'shared' : ''}`, user);
};

export const updateUser = async (id, user, shared = false) => {
	return await request('PUT', `/admin/user/${shared ? 'shared/' : ''}${id}`, user);
};

export const updateUserStatus = async (id, status) => {
	return await request('PUT', `/admin/user/${id}/enabled/${status}`);
};

/* Original User delete.

export const deleteUser = async (id) => {
	return await request('DELETE', `/admin/user/${id}`);
};
*/

export const deleteUser = async (id) => {
	return await request('POST', `/admin/user/${id}/mark_delete`);
};

export const restoreUser = async (id) => {
	return await request('DELETE', `/admin/user/${id}/unmark_delete`);
};

/**
 *  Config API
 */
export const getConfig = async () => {
	return await request('GET', '/admin/config');
};

/**
 *  E-literature
 */
export const getEliterature = async (id) => {
	return await request('GET', `/admin/org/${id}/eliterature`);
};

export const updateEliterature = async (orgId, documentIds) => {
	let form = new FormData();

	form.append('orgId', orgId);
	form.append('selectedSbl', documentIds);

	return await request('POST', '/admin/eliterature/update', form, {}, true);
};

/**
 *  RAG API
 */
// The budget tiers available in the RAG system
export const getRAGTiers = async () => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/tier',
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// The team corresponds to the organization
export const getRAGTeam = async (orgId) => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/team/by-reference?reference=' + orgId,
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// The user corresponds to the user
export const getRAGUser = async (teamID, loginId) => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/user/by-reference?teamID=' + teamID + '&reference=' + loginId,
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// The the team users
export const getRAGTeamUsers = async (teamID) => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/users',
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Register team for the organization
export const postRAGTeam = async (orgId, tierID, canShareQuota, renewalPeriod, isActive) => {
	const result = await request_v2(
		'POST',
		RAG_ENV.baseUrl,
		'/team',
		{
			reference: orgId,
			tierID: tierID,
			canShareQuota: canShareQuota,
			renewalPeriod: renewalPeriod,
			isActive: isActive,
		},
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Edit team for the organization
export const putRAGTeam = async (teamID, orgId, tierID, canShareQuota, renewalPeriod, isActive) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/team/' + teamID,
		{
			reference: orgId.toString(),
			tierID: tierID,
			canShareQuota: canShareQuota,
			renewalPeriod: renewalPeriod,
			isActive: isActive,
		},
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Edit team's budget for the organization
export const putRAGTeamBudget = async (teamID, tierID) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/tier/ ' + tierID,
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Edit team's renewal period for the organization
export const putRAGTeamRenewalPeriod = async (teamID, renewalPeriod) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/renewal-period/ ' + renewalPeriod,
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Register user for to the team (organisation)
export const postRAGUser = async (teamID, loginId, isActive) => {
	const result = await request_v2(
		'POST',
		RAG_ENV.baseUrl,
		'/user',
		{
			teamID: teamID,
			reference: loginId,
			isActive: isActive,
		},
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Get the team's (organization's) upcoming budget changes
export const getRAGTeamBudgetChanges = async (teamID) => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/budget-changes',
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Get the team's (organization's) upcoming renewal period changes
export const getRAGTeamRenewalPeriodChanges = async (teamID) => {
	const result = await request_v2(
		'GET',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/renewal-period-changes',
		null,
		{
			'Content-Type': 'application/json',
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Toggle team for the organization's active status
export const toggleRAGTeamActiveStatus = async (teamID) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/team/' + teamID + '/toggle-active-state',
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Toggle user for the organization's active status
export const toggleRAGUserActiveStatus = async (userId) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/user/' + userId + '/toggle-active-state',
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Toggle user for the organization's active status
export const updateRAGUserDefaultModel = async (userId, defaultModel) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/user/' + userId + '/default-model/' + defaultModel,
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};

// Toggle user for the organization's active status
export const updateRAGUserIsTestMode = async (userId) => {
	const result = await request_v2(
		'PUT',
		RAG_ENV.baseUrl,
		'/user/' + userId + '/toggle-test-mode-state',
		null,
		{
			'X-CLIENT-ID': RAG_ENV.clientId,
			'X-SECRET': RAG_ENV.secret,
		},
		false
	);
	return result;
};


// WEBPACK FOOTER //
// ./src/utils/api.js